module.exports = __webpack_public_path__ + "img/readymsg-logo.a5c3fbfd.png";